import React from 'react'
import styled from 'styled-components'
import { Grid } from '@mui/material'
import { WhiteTextTypography } from './Typography'

const IframeWrapper = styled.div`
  background: white;
  margin-top: 24px;
  margin-bottom: 24px;
`

const Careers = () => (
  <Grid item>
    <WhiteTextTypography gutterBottom variant="h2">
      CAREERS
    </WhiteTextTypography>

    <WhiteTextTypography gutterBottom variant="h4">
      Come join our team!
    </WhiteTextTypography>

    <IframeWrapper>
      <iframe
        id="grnhse_iframe"
        width="100%"
        frameBorder="0"
        scrolling="auto"
        allow="geolocation"
        onLoad={() => window.scrollTo(0, 0)}
        title="GreenSpark Job Board"
        src="https://boards.greenhouse.io/applytogreenspark/"
        height="600"
      />
    </IframeWrapper>

    <WhiteTextTypography gutterBottom variant="h4">
      Don&apos;t see the position you are looking for?
    </WhiteTextTypography>

    <WhiteTextTypography gutterBottom variant="h5">
      Send your resume to hello@greensparksoftware.com. We would love to consider you for our team.
    </WhiteTextTypography>
  </Grid>
)

export default Careers
